import Container from '@components/UI/Container';
import { Navigation } from "@layouts/NavigationV2";
import VersionBanner from '@screens/HelpCenter/Search/VersionBanner';

import React from 'react';

import Banner from './Banner';
import Categories from './Categories';
import Search from './Search/SearchField';

const HelpCenter = ({ categories }) => (
    <>
        <Navigation
            staticTheme="neutral"
            actionTheme="neutral"
            background="bg-violet-900"
        />

        <div
            className='help-center'
        >
            {  <Search />  }

            <Container>
              <VersionBanner className={"mt-5"} />
                <Categories
                    categories={ categories }
                />

                <Banner />
            </Container>
        </div>
    </>
);

export default HelpCenter;
